var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"parameter-tabs",attrs:{"type":"border-card"}},_vm._l((_vm.batParams),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.title}},[_c('parameters',{attrs:{"params":item.params}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }